import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full px-4 md:px-6 lg:px-12 py-12 md:py-16 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8">焦点专题</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {carouselData.map((item, idx) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer transition-all hover:border-primary-200/60"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <CarouselImage idx={idx} title={item.title} />
                <div className="absolute top-3 left-3">
                  <span className="text-xs px-2 py-1 rounded-full bg-background-950/60 text-white backdrop-blur-sm whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-accent-600 font-medium mb-2">{item.subtitle}</p>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CarouselImage({ idx, title }: { idx: number; title: string }) {
  const images = [
    'https://readdy.ai/api/search-image?query=Abstract%20warm%20coral%20and%20gold%20geometric%20flowing%20shapes%20representing%20digital%20entertainment%20and%20media%20trending%20topics%2C%20modern%20minimalist%20art%20with%20cinematic%20lighting%2C%20atmospheric%20depth%2C%20soft%20gradient%20background%2C%20professional%20editorial%20quality&width=600&height=400&seq=carousel-1&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Abstract%20data%20visualization%20art%20with%20warm%20amber%20and%20coral%20flowing%20ribbons%2C%20representing%20trending%20charts%20and%20analytics%2C%20modern%20digital%20art%20style%2C%20soft%20gradient%20with%20rich%20texture%2C%20cinematic%20atmospheric%20lighting&width=600&height=400&seq=carousel-2&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20collage%20of%20overlapping%20translucent%20circles%20in%20coral%20and%20rose%20hues%2C%20representing%20curated%20collections%20and%20highlights%2C%20modern%20minimalist%20editorial%20aesthetic%2C%20soft%20depth%20and%20texture&width=600&height=400&seq=carousel-3&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Abstract%20warm%20peach%20and%20terracotta%20toned%20portrait%20silhouettes%20with%20glowing%20digital%20elements%2C%20representing%20creators%20and%20storytellers%2C%20modern%20artistic%20composition%2C%20atmospheric%20cinematic%20quality&width=600&height=400&seq=carousel-4&orientation=landscape',
  ];
  return (
    <img
      src={images[idx] || images[0]}
      alt={title}
      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
    />
  );
}